import React, { useState } from 'react';
import { GiSemiClosedEye, //visible
 } from 'react-icons/gi';
import colors from '../../assets/colors';
import './ListItem.css';
const ListItem = (props) => {
    const { selected, image, title, color, callback } = props;
    const [hovered, setHovered] = useState(false);
    return (React.createElement("div", { className: `ListItem ${hovered ? 'hovered' : ''} ${selected ? 'selected' : ''}`, onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false), onClick: callback },
        selected &&
            React.createElement("div", { className: 'selected-indicator' },
                React.createElement(GiSemiClosedEye, { color: colors.primary.black, size: 16 })),
        React.createElement("div", { className: 'icon', style: color ?
                {
                    border: `4px solid ${color}`,
                    borderRadius: '50%',
                    height: 50
                } : undefined },
            React.createElement("img", { src: image })),
        title));
};
export default ListItem;
